module.exports = __webpack_public_path__ + "static/img/c-sd.cdbc31ae.png";